var _clipPath, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _g2, _g3, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 600,
    width: 1200,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v150h700v150H600zm600 0H300v350H0v-50z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1200v600H0z",
    fill: "#012169"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m0 0 600 300m0-300L0 300",
    stroke: "#fff",
    strokeWidth: 60
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#a)",
    d: "m0 0 600 300m0-300L0 300",
    stroke: "#c8102e",
    strokeWidth: 40
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M300 0v350M0 150h700",
    stroke: "#fff",
    strokeWidth: 100
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M300 0v350M0 150h700",
    stroke: "#c8102e",
    strokeWidth: 60
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 300h600V0h200v400H0z",
    fill: "#012169"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M784.8 156c0 151.011 17.51 203.045 52.565 238.1C858.27 414.853 867.539 422.662 900 444c32.461-21.337 41.729-29.146 62.636-49.9 35.053-35.055 52.564-87.089 52.564-238.1-25.497 10.917-40.026 16.209-61.051 15.885-18.809-.29-38.737-9.024-54.149-15.885-15.412 6.86-35.34 15.595-54.148 15.885-21.026.324-35.555-4.968-61.052-15.885z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.50845 0 0 3.34488 -47.153 -59.398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271 87c1.543 3.63 6.49 7.637 7.85 9.601-1.731 1.964-2.077 1.75-1.85 5.399 3.01-3.15 3.064-3.478 5-3 4.241 4.232.759 13.321-2.746 15.297-3.504 2.108-2.868-.073-8.12 2.569 2.408 2.059 5.198-.302 7.478.329 1.239 1.47-.589 4.149.374 6.672 2.015-.194 1.773-4.262 2.242-5.737C282.7 112.726 291.55 108.957 292 104c1.866-.876 3.731-.274 6 1-1.13-4.644-4.868-4.594-5.87-6.044-2.385-3.645-4.499-7.803-9.593-8.881-3.867-.82-3.578.246-6.056-1.444-1.543-1.202-6.231-3.474-5.481-1.631z",
    fill: "#f90"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281.317,
    cy: 91.128,
    fill: "#fff",
    fillRule: "evenodd",
    r: 0.806
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.639 -2.95744 3.10207 -1.56258 1034.545 1220.517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271 87c1.543 3.63 6.49 7.637 7.85 9.601-1.731 1.964-2.077 1.75-1.85 5.399 3.01-3.15 3.064-3.478 5-3 4.241 4.232.759 13.321-2.746 15.297-3.504 2.108-2.868-.073-8.12 2.569 2.408 2.059 5.198-.302 7.478.329 1.239 1.47-.589 4.149.374 6.672 2.015-.194 1.773-4.262 2.242-5.737C282.7 112.726 291.55 108.957 292 104c1.866-.876 3.731-.274 6 1-1.13-4.644-4.868-4.594-5.87-6.044-2.385-3.645-4.499-7.803-9.593-8.881-3.867-.82-3.578.246-6.056-1.444-1.543-1.202-6.231-3.474-5.481-1.631z",
    fill: "#f90"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281.317,
    cy: 91.128,
    fill: "#fff",
    fillRule: "evenodd",
    r: 0.806
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.80698 2.86712 -3.00733 -1.72273 1682.51 -336.808)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271 87c1.543 3.63 6.49 7.637 7.85 9.601-1.731 1.964-2.077 1.75-1.85 5.399 3.01-3.15 3.064-3.478 5-3 4.241 4.232.759 13.321-2.746 15.297-3.504 2.108-2.868-.073-8.12 2.569 2.408 2.059 5.198-.302 7.478.329 1.239 1.47-.589 4.149.374 6.672 2.015-.194 1.773-4.262 2.242-5.737C282.7 112.726 291.55 108.957 292 104c1.866-.876 3.731-.274 6 1-1.13-4.644-4.868-4.594-5.87-6.044-2.385-3.645-4.499-7.803-9.593-8.881-3.867-.82-3.578.246-6.056-1.444-1.543-1.202-6.231-3.474-5.481-1.631z",
    fill: "#f90"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281.317,
    cy: 91.128,
    fill: "#fff",
    fillRule: "evenodd",
    r: 0.806
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M813.698 362.055c6.72 12.755 14.602 22.979 23.668 32.044C858.272 414.854 867.539 422.663 900 444c32.461-21.337 41.73-29.146 62.637-49.9 9.065-9.066 16.945-19.29 23.665-32.045z",
    fill: "#9cf"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M780 150c0 157.303 18.24 211.506 54.755 248.02C856.532 419.64 866.186 427.774 900 450c33.814-22.226 43.468-30.36 65.245-51.98C1001.76 361.506 1020 307.303 1020 150c-26.559 11.371-41.694 16.884-63.595 16.547-19.592-.302-40.351-9.4-56.405-16.547-16.054 7.146-36.813 16.245-56.405 16.547-21.901.337-37.036-5.176-63.595-16.547zm7.2 8.4c24.965 10.735 39.192 15.94 59.78 15.621 18.416-.285 37.93-8.875 53.02-15.621 15.09 6.746 34.604 15.337 53.02 15.621 20.588.318 34.815-4.886 59.78-15.621 0 148.494-17.145 199.662-51.469 234.131C940.861 412.94 931.785 420.62 900 441.6c-31.785-20.981-40.86-28.66-61.331-49.069-34.324-34.47-51.469-85.637-51.469-234.131z",
    fill: "#fdc301"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.8000cb35fcab2ac6dcfff69e86736dad.svg";
export { ForwardRef as ReactComponent };